import { Callout } from "@octopusdeploy/design-system-components";
import type React from "react";
export const DeleteStepsCallout: React.FC = () => {
    return (<Callout title="This is a destructive action" type={"danger"}>
            This action <strong>cannot</strong> be undone. This will permanently delete all steps from this process.
        </Callout>);
};
DeleteStepsCallout.displayName = "DeleteStepsCallout"
